<template>
    <div class="mpS1">
        <div class="mps1-phone">
            <img src="@/assets/mcp3-img.png" alt="">
        
        <div class="mps1-text1">
            ON STYLE LIVE는 라이브 커머스 서비스입니다
        </div>
         <div class="mps1-text2">
             -실시간 라이브 방송,상품 무료 홍보 등 서비스를 지원하고 있습니다
         </div>
          <div class="mps1-btn">
              <router-link to="/mjoinus" class="joinbtn">준비중입니다</router-link>
          </div>
          </div>
    </div>
</template>
<script>
export default {
    name: "mpSlide1"
}
</script>
<style lang="scss" scoped>
.mpS1 {
    width: 100%;
    position: relative;
    .mps1-phone {
        width: 100%;
        padding: 100px 15px 70px 10px;
        box-sizing: border-box;
        background-color: #bfdfd9;
        text-align: center;
        position: relative;
        img {
            width: 60%;
        }
    }
    .mps1-text1 {
        width: 100%;
        padding: 20px 15px 5px 15px;
        box-sizing: border-box;
        font-size: 18px;
        font-weight: 900;
        color: rgb(89, 89, 89);
    }
    .mps1-text2 {
         width: 100%;
        padding: 0px 15px 10px 15px;
        box-sizing: border-box;
        color: #a1a1a1;
        margin-bottom: 30px;
    }
    .mps1-btn {
        width: 100%;
        position: relative;
        .joinbtn {
            padding: 15px 50px;
            height: 100%;
            text-decoration: none;
            color: #ffffff;
            background-color: #aca599;
            border-radius: 30px;
        }
    }
}
</style>